<template>
    <div class="modal" tabindex="-1" role="dialog" id="shareFavoritesLink" aria-labelledby="shareFavoritesLink" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{message('share.modal.copy')}}:</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" class="icon icon-close"></span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <h4>{{message('share.modal.usa')}}</h4>
                    <div class="share-favorites-link">
                        <input ref="share-input" class="form-control m-t-md m-b-md" name="" :value="link" />
                        <a href="#" @click.prevent="copyToClipboard" class="btn btn-primary" type="button">{{message('share.modal.copy')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import message from '../i18n'

    export default {
        name: "ShareModal",
        props: {
            link: String
        },
        methods : {
            message: message,
            copyToClipboard() {
                this.$refs['share-input'].select();
                document.execCommand('copy');
            }
        }
    }
</script>

<style scoped>

</style>